<template>
    <NebulaGridRow type="flex">
        <NebulaColumn :columns="12">
            <NebulaBreadcrumbs
                :aria-label="$t('Breadcrumbs with dropdown and custom aria label')"
                :breadcrumbs="breadcrumbs"
                dropdownUseRouterLinks
                showDimText
            />
        </NebulaColumn>
    </NebulaGridRow>
</template>

<script>
import { NebulaGrid, NebulaBreadcrumbs } from '@discoveryedu/nebula-components';
import { useMainStore } from '@/stores/useMainStore';
import { useAppStore } from '@/stores/useAppStore';

export default {
    setup() {
        const store = useMainStore();
        const appStore = useAppStore();
        return { store, appStore };
    },
    name: 'BreadcrumbsRow',
    components: {
        NebulaGridRow: NebulaGrid.NebulaGridRow,
        NebulaColumn: NebulaGrid.NebulaColumn,
        NebulaBreadcrumbs,
    },
    computed: {
        breadcrumbs() {
            const storedBreadcrumbs = this.appStore.breadcrumb || [];

            // If no breadcrumbs at all, return empty (don't show anything)
            if (storedBreadcrumbs.length === 0) {
                return [];
            }

            // Ensure Dashboard is always first
            const firstBreadcrumb = storedBreadcrumbs[0];
            if (firstBreadcrumb.text === 'Dashboard') {
                return storedBreadcrumbs;
            }

            // Dashboard not first: prepend it
            const dashboardBreadcrumb = {
                dim_text: '',
                link: '/',
                text: this.$t('Dashboard'),
            };
            return [dashboardBreadcrumb, ...storedBreadcrumbs];
        },
    },
};
</script>
